const countries = [
  {
    countryNameEn: 'Andorra',
    countryNameLocal: 'Andorra',
    countryCode: 'AD',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    countryCallingCode: '376',
    region: 'Europe',
    flag: '🇦🇩',
  },
  {
    countryNameEn: 'Afghanistan',
    countryNameLocal: 'د افغانستان اسلامي دولتدولت اسلامی افغانستان, جمهوری اسلامی افغانستان',
    countryCode: 'AF',
    currencyCode: 'AFN',
    currencyNameEn: 'Afghan afghani',
    tinType: '',
    tinName: '',
    countryCallingCode: '93',
    region: 'Asia & Pacific',
    flag: '🇦🇫',
  },
  {
    countryNameEn: 'Antigua and Barbuda',
    countryNameLocal: 'Antigua and Barbuda',
    countryCode: 'AG',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1268',
    region: 'South/Latin America',
    flag: '🇦🇬',
  },
  {
    countryNameEn: 'Anguilla',
    countryNameLocal: 'Anguilla',
    countryCode: 'AI',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1264',
    region: 'South/Latin America',
    flag: '🇦🇮',
  },
  {
    countryNameEn: 'Albania',
    countryNameLocal: 'Shqipëria',
    countryCode: 'AL',
    currencyCode: 'ALL',
    currencyNameEn: 'Albanian lek',
    tinType: 'NIPT',
    tinName: 'Numri i Identifikimit për Personin e Tatueshëm',
    countryCallingCode: '355',
    region: 'Europe',
    flag: '🇦🇱',
  },
  {
    countryNameEn: 'Armenia',
    countryNameLocal: 'Հայաստան',
    countryCode: 'AM',
    currencyCode: 'AMD',
    currencyNameEn: 'Armenian dram',
    tinType: '',
    tinName: '',
    countryCallingCode: '374',
    region: 'Europe',
    flag: '🇦🇲',
  },
  {
    countryNameEn: 'Angola',
    countryNameLocal: 'Angola',
    countryCode: 'AO',
    currencyCode: 'AOA',
    currencyNameEn: 'Angolan kwanza',
    tinType: '',
    tinName: '',
    countryCallingCode: '244',
    region: 'Africa',
    flag: '🇦🇴',
  },
  {
    countryNameEn: 'Antarctica',
    countryNameLocal: 'Antarctica, Antártico, Antarctique, Антарктике',
    countryCode: 'AQ',
    currencyCode: '',
    currencyNameEn: '',
    tinType: '',
    tinName: '',
    countryCallingCode: '672',
    region: 'Asia & Pacific',
    flag: '🇦🇶',
  },
  {
    countryNameEn: 'Argentina',
    countryNameLocal: 'Argentina',
    countryCode: 'AR',
    currencyCode: 'ARS',
    currencyNameEn: 'Argentine peso',
    tinType: 'CUIT',
    tinName: 'Código Único de Identificación Tributaria',
    countryCallingCode: '54',
    region: 'South/Latin America',
    flag: '🇦🇷',
  },
  {
    countryNameEn: 'American Samoa',
    countryNameLocal: 'American Samoa',
    countryCode: 'AS',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1684',
    region: 'Asia & Pacific',
    flag: '🇦🇸',
  },
  {
    countryNameEn: 'Austria',
    countryNameLocal: 'Österreich',
    countryCode: 'AT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'UID',
    tinName: 'Umsatzsteuer-Identifikationsnummer',
    countryCallingCode: '43',
    region: 'Europe',
    flag: '🇦🇹',
  },
  {
    countryNameEn: 'Australia',
    countryNameLocal: 'Australia',
    countryCode: 'AU',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: 'ABN',
    tinName: 'Australian Business Number',
    countryCallingCode: '61',
    region: 'Asia & Pacific',
    flag: '🇦🇺',
  },
  {
    countryNameEn: 'Aruba',
    countryNameLocal: 'Aruba',
    countryCode: 'AW',
    currencyCode: 'AWG',
    currencyNameEn: 'Aruban florin',
    tinType: '',
    tinName: '',
    countryCallingCode: '297',
    region: 'South/Latin America',
    flag: '🇦🇼',
  },
  {
    countryNameEn: 'Åland Islands',
    countryNameLocal: 'Åland',
    countryCode: 'AX',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    countryCallingCode: '358',
    region: 'Europe',
    flag: '🇦🇽',
  },
  {
    countryNameEn: 'Azerbaijan',
    countryNameLocal: 'Azərbaycan',
    countryCode: 'AZ',
    currencyCode: 'AZN',
    currencyNameEn: 'Azerbaijani manat',
    tinType: '',
    tinName: '',
    countryCallingCode: '994',
    region: 'Asia & Pacific',
    flag: '🇦🇿',
  },
  {
    countryNameEn: 'Bosnia and Herzegovina',
    countryNameLocal: 'Bosna i Hercegovina',
    countryCode: 'BA',
    currencyCode: 'BAM',
    currencyNameEn: 'Bosnia and Herzegovina convertible mark',
    tinType: '',
    tinName: '',
    countryCallingCode: '387',
    region: 'Europe',
    flag: '🇧🇦',
  },
  {
    countryNameEn: 'Barbados',
    countryNameLocal: 'Barbados',
    countryCode: 'BB',
    currencyCode: 'BBD',
    currencyNameEn: 'Barbados dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1246',
    region: 'South/Latin America',
    flag: '🇧🇧',
  },
  {
    countryNameEn: 'Bangladesh',
    countryNameLocal: 'গণপ্রজাতন্ত্রী বাংলাদেশ',
    countryCode: 'BD',
    currencyCode: 'BDT',
    currencyNameEn: 'Bangladeshi taka',
    tinType: '',
    tinName: '',
    countryCallingCode: '880',
    region: 'Asia & Pacific',
    flag: '🇧🇩',
  },
  {
    countryNameEn: 'Belgium',
    countryNameLocal: 'België, Belgique, Belgien',
    countryCode: 'BE',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'n° TVABTW-nr Mwst-nr',
    tinName: 'BTW identificatienummer / Numéro de TVA',
    countryCallingCode: '32',
    region: 'Europe',
    flag: '🇧🇪',
  },
  {
    countryNameEn: 'Burkina Faso',
    countryNameLocal: 'Burkina Faso',
    countryCode: 'BF',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',
    countryCallingCode: '226',
    region: 'Africa',
    flag: '🇧🇫',
  },
  {
    countryNameEn: 'Bulgaria',
    countryNameLocal: 'България',
    countryCode: 'BG',
    currencyCode: 'BGN',
    currencyNameEn: 'Bulgarian lev',
    tinType: 'ДДС номер',
    tinName: 'Идентификационен номер по ДДС',
    countryCallingCode: '359',
    region: 'Europe',
    flag: '🇧🇬',
  },
  {
    countryNameEn: 'Bahrain',
    countryNameLocal: 'البحرين',
    countryCode: 'BH',
    currencyCode: 'BHD',
    currencyNameEn: 'Bahraini dinar',
    tinType: '',
    tinName: '',
    countryCallingCode: '973',
    region: 'Arab States',
    flag: '🇧🇭',
  },
  {
    countryNameEn: 'Burundi',
    countryNameLocal: 'Burundi',
    countryCode: 'BI',
    currencyCode: 'BIF',
    currencyNameEn: 'Burundian franc',
    tinType: '',
    tinName: '',

    countryCallingCode: '257',
    region: 'Africa',
    flag: '🇧🇮',
  },
  {
    countryNameEn: 'Benin',
    countryNameLocal: 'Bénin',
    countryCode: 'BJ',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',

    countryCallingCode: '229',
    region: 'Africa',
    flag: '🇧🇯',
  },
  {
    countryNameEn: 'Saint Barthélemy',
    countryNameLocal: 'Saint-Barthélemy',
    countryCode: 'BL',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',

    countryCallingCode: '590',
    region: 'South/Latin America',
    flag: '🇧🇱',
  },
  {
    countryNameEn: 'Bermuda',
    countryNameLocal: 'Bermuda',
    countryCode: 'BM',
    currencyCode: 'BMD',
    currencyNameEn: 'Bermudian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1441',
    region: 'North America',
    flag: '🇧🇲',
  },
  {
    countryNameEn: 'Brunei Darussalam',
    countryNameLocal: 'Brunei Darussalam',
    countryCode: 'BN',
    currencyCode: 'BND',
    currencyNameEn: 'Brunei dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '673',
    region: 'Asia & Pacific',
    flag: '🇧🇳',
  },
  {
    countryNameEn: 'Bolivia (Plurinational State of)',
    countryNameLocal: 'Bolivia, Bulibiya, Volívia, Wuliwya',
    countryCode: 'BO',
    currencyCode: 'BOP',
    currencyNameEn: '',
    tinType: 'NIT',
    tinName: 'Número de Identificación Tributaria',
    countryCallingCode: '591',
    region: 'South/Latin America',
    flag: '🇧🇴',
  },
  {
    countryNameEn: 'Bonaire, Sint Eustatius and Saba',
    countryNameLocal: 'Caribisch Nederland',
    countryCode: 'BQ',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '5997',
    region: 'Unknown',
    flag: '🇧🇶',
  },
  {
    countryNameEn: 'Brazil',
    countryNameLocal: 'Brasil',
    countryCode: 'BR',
    currencyCode: 'BRL',
    currencyNameEn: 'Brazilian real',
    tinType: 'CNPJ',
    tinName: 'Cadastro Nacional de Pessoa Jurídica',
    countryCallingCode: '55',
    region: 'South/Latin America',
    flag: '🇧🇷',
  },
  {
    countryNameEn: 'Bhutan',
    countryNameLocal: 'འབྲུག་ཡུལ',
    countryCode: 'BT',
    currencyCode: 'BTN',
    currencyNameEn: 'Bhutanese ngultrum',
    tinType: '',
    tinName: '',
    countryCallingCode: '975',
    region: 'Asia & Pacific',
    flag: '🇧🇹',
  },
  {
    countryNameEn: 'Bouvet Island',
    countryNameLocal: 'Bouvetøya',
    countryCode: 'BV',
    currencyCode: 'NOK',
    currencyNameEn: 'Norwegian krone',
    tinType: '',
    tinName: '',
    countryCallingCode: '47',
    region: 'South/Latin America',
    flag: '🇧🇻',
  },
  {
    countryNameEn: 'Botswana',
    countryNameLocal: 'Botswana',
    countryCode: 'BW',
    currencyCode: 'BWP',
    currencyNameEn: 'Botswana pula',
    tinType: '',
    tinName: '',
    countryCallingCode: '267',
    region: 'Africa',
    flag: '🇧🇼',
  },
  {
    countryNameEn: 'Belarus',
    countryNameLocal: 'Беларусь',
    countryCode: 'BY',
    currencyCode: 'BYR',
    currencyNameEn: '',
    tinType: 'УНП (UNP)',
    tinName: 'Учетный номер плательщика',
    countryCallingCode: '375',
    region: 'Europe',
    flag: '🇧🇾',
  },
  {
    countryNameEn: 'Belize',
    countryNameLocal: 'Belize',
    countryCode: 'BZ',
    currencyCode: 'BZD',
    currencyNameEn: 'Belize dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '501',
    region: 'South/Latin America',
    flag: '🇧🇿',
  },
  {
    countryNameEn: 'Canada',
    countryNameLocal: 'Canada',
    countryCode: 'CA',
    currencyCode: 'CAD',
    currencyNameEn: 'Canadian dollar',
    tinType: 'BN / NE',
    tinName: 'Business Number',
    countryCallingCode: '1',
    region: 'North America',
    flag: '🇨🇦',
  },
  {
    countryNameEn: 'Switzerland',
    countryNameLocal: 'Schweiz, Suisse, Svizzera, Svizra',
    countryCode: 'CH',
    currencyCode: 'CHE',
    currencyNameEn: 'WIR Euro (complementary currency)',
    tinType: 'MWST/TVA/IVA',
    tinName: 'Mehrwertsteuernummer',
    countryCallingCode: '41',
    region: 'Europe',
    flag: '🇨🇭',
  },
  {
    countryNameEn: "Côte d'Ivoire",
    countryNameLocal: "Côte d'Ivoire",
    countryCode: 'CI',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',

    countryCallingCode: '225',
    region: 'Africa',
    flag: '🇨🇮',
  },
  {
    countryNameEn: 'Chile',
    countryNameLocal: 'Chile',
    countryCode: 'CL',
    currencyCode: 'CLP',
    currencyNameEn: 'Chilean peso',
    tinType: 'RUT',
    tinName: 'Rol Único Tributario',

    countryCallingCode: '56',
    region: 'South/Latin America',
    flag: '🇨🇱',
  },
  {
    countryNameEn: 'Cameroon',
    countryNameLocal: 'Cameroun, Cameroon',
    countryCode: 'CM',
    currencyCode: 'XAF',
    currencyNameEn: 'CFA franc BEAC',
    tinType: '',
    tinName: '',

    countryCallingCode: '237',
    region: 'Africa',
    flag: '🇨🇲',
  },
  {
    countryNameEn: 'China',
    countryNameLocal: '中国',
    countryCode: 'CN',
    currencyCode: 'CNY',
    currencyNameEn: 'Renminbi (Chinese) yuan',
    tinType: '',
    tinName: '',

    countryCallingCode: '86',
    region: 'Asia & Pacific',
    flag: '🇨🇳',
  },
  {
    countryNameEn: 'Colombia',
    countryNameLocal: 'Colombia',
    countryCode: 'CO',
    currencyCode: 'COP',
    currencyNameEn: 'Colombian peso',
    tinType: 'NIT',
    tinName: 'Número De Identificación Tributaria',

    countryCallingCode: '57',
    region: 'South/Latin America',
    flag: '🇨🇴',
  },
  {
    countryNameEn: 'Costa Rica',
    countryNameLocal: 'Costa Rica',
    countryCode: 'CR',
    currencyCode: 'CRC',
    currencyNameEn: 'Costa Rican colon',
    tinType: '',
    tinName: 'Cédula Jurídica',

    countryCallingCode: '506',
    region: 'South/Latin America',
    flag: '🇨🇷',
  },
  {
    countryNameEn: 'Cuba',
    countryNameLocal: 'Cuba',
    countryCode: 'CU',
    currencyCode: 'CUC',
    currencyNameEn: 'Cuban convertible peso',
    tinType: '',
    tinName: '',

    countryCallingCode: '53',
    region: 'South/Latin America',
    flag: '🇨🇺',
  },
  {
    countryNameEn: 'Cabo Verde',
    countryNameLocal: 'Cabo Verde',
    countryCode: 'CV',
    currencyCode: 'CVE',
    currencyNameEn: 'Cape Verdean escudo',
    tinType: '',
    tinName: '',

    countryCallingCode: '238',
    region: 'Africa',
    flag: '🇨🇻',
  },
  {
    countryNameEn: 'Curaçao',
    countryNameLocal: 'Curaçao',
    countryCode: 'CW',
    currencyCode: 'ANG',
    currencyNameEn: 'Netherlands Antillean guilder',
    tinType: '',
    tinName: '',

    countryCallingCode: '599',
    region: 'Unknown',
    flag: '🇨🇼',
  },
  {
    countryNameEn: 'Christmas Island',
    countryNameLocal: 'Christmas Island',
    countryCode: 'CX',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '61',
    region: 'Asia & Pacific',
    flag: '🇨🇽',
  },
  {
    countryNameEn: 'Cyprus',
    countryNameLocal: 'Κύπρος, Kibris',
    countryCode: 'CY',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'ΦΠΑ',
    tinName: 'Αριθμός Εγγραφής Φ.Π.Α.',

    countryCallingCode: '357',
    region: 'Europe',
    flag: '🇨🇾',
  },
  {
    countryNameEn: 'Germany',
    countryNameLocal: 'Deutschland',
    countryCode: 'DE',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'USt-IdNr.',
    tinName: 'Umsatzsteuer-Identifikationsnummer',

    countryCallingCode: '49',
    region: 'Europe',
    flag: '🇩🇪',
  },
  {
    countryNameEn: 'Djibouti',
    countryNameLocal: 'Djibouti, جيبوتي, Jabuuti, Gabuutih',
    countryCode: 'DJ',
    currencyCode: 'DJF',
    currencyNameEn: 'Djiboutian franc',
    tinType: '',
    tinName: '',

    countryCallingCode: '253',
    region: 'Arab States',
    flag: '🇩🇯',
  },
  {
    countryNameEn: 'Denmark',
    countryNameLocal: 'Danmark',
    countryCode: 'DK',
    currencyCode: 'DKK',
    currencyNameEn: 'Danish krone',
    tinType: 'CVR',
    tinName: 'Momsregistreringsnummer',

    countryCallingCode: '45',
    region: 'Europe',
    flag: '🇩🇰',
  },
  {
    countryNameEn: 'Dominica',
    countryNameLocal: 'Dominica',
    countryCode: 'DM',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '767',
    region: 'South/Latin America',
    flag: '🇩🇲',
  },
  {
    countryNameEn: 'Algeria',
    countryNameLocal: 'الجزائر',
    countryCode: 'DZ',
    currencyCode: 'DZD',
    currencyNameEn: 'Algerian dinar',
    tinType: '',
    tinName: '',

    countryCallingCode: '213',
    region: 'Arab States',
    flag: '🇩🇿',
  },
  {
    countryNameEn: 'Ecuador',
    countryNameLocal: 'Ecuador',
    countryCode: 'EC',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: 'RUC',
    tinName: 'Número de Registro Unico de Contribuyentes',

    countryCallingCode: '593',
    region: 'South/Latin America',
    flag: '🇪🇨',
  },
  {
    countryNameEn: 'Estonia',
    countryNameLocal: 'Eesti',
    countryCode: 'EE',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'KMKR',
    tinName: 'Käibemaksukohustuslase number',
    countryCallingCode: '372',
    region: 'Europe',
    flag: '🇪🇪',
  },
  {
    countryNameEn: 'Egypt',
    countryNameLocal: 'مصر',
    countryCode: 'EG',
    currencyCode: 'EGP',
    currencyNameEn: 'Egyptian pound',
    tinType: '',
    tinName: '',

    countryCallingCode: '20',
    region: 'Arab States',
    flag: '🇪🇬',
  },
  {
    countryNameEn: 'Western Sahara',
    countryNameLocal: 'Sahara Occidental',
    countryCode: 'EH',
    currencyCode: 'MAD',
    currencyNameEn: 'Moroccan dirham',
    tinType: '',
    tinName: '',

    countryCallingCode: '212',
    region: 'Africa',
    flag: '🇪🇭',
  },
  {
    countryNameEn: 'Eritrea',
    countryNameLocal: 'ኤርትራ, إرتريا, Eritrea',
    countryCode: 'ER',
    currencyCode: 'ERN',
    currencyNameEn: 'Eritrean nakfa',
    tinType: '',
    tinName: '',
    countryCallingCode: '291',
    region: 'Africa',
    flag: '🇪🇷',
  },
  {
    countryNameEn: 'Spain',
    countryNameLocal: 'España',
    countryCode: 'ES',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'NIF (CIF)',
    tinName: 'Número de Identificación Fiscal (formerly named Código de Identificación Fiscal)',
    countryCallingCode: '34',
    region: 'Europe',
    flag: '🇪🇸',
  },
  {
    countryNameEn: 'Ethiopia',
    countryNameLocal: 'ኢትዮጵያ, Itoophiyaa',
    countryCode: 'ET',
    currencyCode: 'ETB',
    currencyNameEn: 'Ethiopian birr',
    tinType: '',
    tinName: '',
    countryCallingCode: '251',
    region: 'Africa',
    flag: '🇪🇹',
  },
  {
    countryNameEn: 'Finland',
    countryNameLocal: 'Suomi',
    countryCode: 'FI',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'ALV nro',
    tinName: 'Arvonlisäveronumero',
    countryCallingCode: '358',
    region: 'Europe',
    flag: '🇫🇮',
  },
  {
    countryNameEn: 'Fiji',
    countryNameLocal: 'Fiji',
    countryCode: 'FJ',
    currencyCode: 'FJD',
    currencyNameEn: 'Fiji dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '679',
    region: 'Asia & Pacific',
    flag: '🇫🇯',
  },
  {
    countryNameEn: 'Micronesia (Federated States of)',
    countryNameLocal: 'Micronesia',
    countryCode: 'FM',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '691',
    region: 'Asia & Pacific',
    flag: '🇫🇲',
  },
  {
    countryNameEn: 'France',
    countryNameLocal: 'France',
    countryCode: 'FR',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'n° TVA',
    tinName:
      "Numéro d'identification à la taxe sur la valeur ajoutée / Numéro de TVA intracommunautaire",
    countryCallingCode: '33',
    region: 'Europe',
    flag: '🇫🇷',
  },
  {
    countryNameEn: 'Gabon',
    countryNameLocal: 'Gabon',
    countryCode: 'GA',
    currencyCode: 'XAF',
    currencyNameEn: 'CFA franc BEAC',
    tinType: '',
    tinName: '',
    countryCallingCode: '241',
    region: 'Africa',
    flag: '🇬🇦',
  },
  {
    countryNameEn: 'Grenada',
    countryNameLocal: 'Grenada',
    countryCode: 'GD',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1473',
    region: 'South/Latin America',
    flag: '🇬🇩',
  },
  {
    countryNameEn: 'Georgia',
    countryNameLocal: 'საქართველო',
    countryCode: 'GE',
    currencyCode: 'GEL',
    currencyNameEn: 'Georgian lari',
    tinType: '',
    tinName: '',
    countryCallingCode: '995',
    region: 'Europe',
    flag: '🇬🇪',
  },
  {
    countryNameEn: 'French Guiana',
    countryNameLocal: 'Guyane française',
    countryCode: 'GF',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    countryCallingCode: '594',
    region: 'South/Latin America',
    flag: '🇬🇫',
  },
  {
    countryNameEn: 'Guernsey',
    countryNameLocal: 'Guernsey',
    countryCode: 'GG',
    currencyCode: 'GBP',
    currencyNameEn: 'Pound sterling',
    tinType: '',
    tinName: '',
    countryCallingCode: '44',
    region: 'Europe',
    flag: '🇬🇬',
  },
  {
    countryNameEn: 'Ghana',
    countryNameLocal: 'Ghana',
    countryCode: 'GH',
    currencyCode: 'GHS',
    currencyNameEn: 'Ghanaian cedi',
    tinType: '',
    tinName: '',
    countryCallingCode: '233',
    region: 'Africa',
    flag: '🇬🇭',
  },
  {
    countryNameEn: 'Gibraltar',
    countryNameLocal: 'Gibraltar',
    countryCode: 'GI',
    currencyCode: 'GIP',
    currencyNameEn: 'Gibraltar pound',
    tinType: '',
    tinName: '',
    countryCallingCode: '350',
    region: 'Europe',
    flag: '🇬🇮',
  },
  {
    countryNameEn: 'Greenland',
    countryNameLocal: 'Kalaallit Nunaat, Grønland',
    countryCode: 'GL',
    currencyCode: 'DKK',
    currencyNameEn: 'Danish krone',
    tinType: '',
    tinName: '',
    countryCallingCode: '299',
    region: 'Europe',
    flag: '🇬🇱',
  },
  {
    countryNameEn: 'Guinea',
    countryNameLocal: 'Guinée',
    countryCode: 'GN',
    currencyCode: 'GNF',
    currencyNameEn: 'Guinean franc',
    tinType: '',
    tinName: '',

    countryCallingCode: '224',
    region: 'Africa',
    flag: '🇬🇳',
  },
  {
    countryNameEn: 'Guadeloupe',
    countryNameLocal: 'Guadeloupe',
    countryCode: 'GP',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',

    countryCallingCode: '590',
    region: 'South/Latin America',
    flag: '🇬🇵',
  },
  {
    countryNameEn: 'Equatorial Guinea',
    countryNameLocal: 'Guiena ecuatorial, Guinée équatoriale, Guiné Equatorial',
    countryCode: 'GQ',
    currencyCode: 'XAF',
    currencyNameEn: 'CFA franc BEAC',
    tinType: '',
    tinName: '',

    countryCallingCode: '240',
    region: 'Africa',
    flag: '🇬🇶',
  },
  {
    countryNameEn: 'Greece',
    countryNameLocal: 'Ελλάδα',
    countryCode: 'GR',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',

    countryCallingCode: '30',
    region: 'Europe',
    flag: '🇬🇷',
  },
  {
    countryNameEn: 'South Georgia and the South Sandwich Islands',
    countryNameLocal: 'South Georgia and the South Sandwich Islands',
    countryCode: 'GS',
    currencyCode: '',
    currencyNameEn: '',
    tinType: '',
    tinName: '',
    countryCallingCode: '500',
    region: 'South/Latin America',
    flag: '🇬🇸',
  },
  {
    countryNameEn: 'Guatemala',
    countryNameLocal: 'Guatemala',
    countryCode: 'GT',
    currencyCode: 'GTQ',
    currencyNameEn: 'Guatemalan quetzal',
    tinType: 'NIT',
    tinName: 'Número de Identificación Tributaria',

    countryCallingCode: '502',
    region: 'South/Latin America',
    flag: '🇬🇹',
  },
  {
    countryNameEn: 'Guam',
    countryNameLocal: 'Guam, Guåhån',
    countryCode: 'GU',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1',
    region: 'Asia & Pacific',
    flag: '🇬🇺',
  },
  {
    countryNameEn: 'Guinea-Bissau',
    countryNameLocal: 'Guiné-Bissau',
    countryCode: 'GW',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',

    countryCallingCode: '245',
    region: 'Africa',
    flag: '🇬🇼',
  },
  {
    countryNameEn: 'Guyana',
    countryNameLocal: 'Guyana',
    countryCode: 'GY',
    currencyCode: 'GYD',
    currencyNameEn: 'Guyanese dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '592',
    region: 'South/Latin America',
    flag: '🇬🇾',
  },
  {
    countryNameEn: 'Hong Kong',
    countryNameLocal: '香港, Hong Kong',
    countryCode: 'HK',
    currencyCode: 'HKD',
    currencyNameEn: 'Hong Kong dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '852',
    region: 'Asia & Pacific',
    flag: '🇭🇰',
  },
  {
    countryNameEn: 'Honduras',
    countryNameLocal: 'Honduras',
    countryCode: 'HN',
    currencyCode: 'HNL',
    currencyNameEn: 'Honduran lempira',
    tinType: 'RTN',
    tinName: 'Registro Tributario Nacional',

    countryCallingCode: '504',
    region: 'South/Latin America',
    flag: '🇭🇳',
  },
  {
    countryNameEn: 'Croatia',
    countryNameLocal: 'Hrvatska',
    countryCode: 'HR',
    currencyCode: 'HRK',
    currencyNameEn: 'Croatian kuna',
    tinType: 'PDV-ID; OIB',
    tinName: 'PDV Id. Broj OIB',
    countryCallingCode: '385',
    region: 'Europe',
    flag: '🇭🇷',
  },
  {
    countryNameEn: 'Haiti',
    countryNameLocal: 'Haïti, Ayiti',
    countryCode: 'HT',
    currencyCode: 'HTG',
    currencyNameEn: 'Haitian gourde',
    tinType: '',
    tinName: '',

    countryCallingCode: '509',
    region: 'South/Latin America',
    flag: '🇭🇹',
  },
  {
    countryNameEn: 'Hungary',
    countryNameLocal: 'Magyarország',
    countryCode: 'HU',
    currencyCode: 'HUF',
    currencyNameEn: 'Hungarian forint',
    tinType: 'ANUM',
    tinName: 'Közösségi adószám',
    countryCallingCode: '36',
    region: 'Europe',
    flag: '🇭🇺',
  },
  {
    countryNameEn: 'Indonesia',
    countryNameLocal: 'Indonesia',
    countryCode: 'ID',
    currencyCode: 'IDR',
    currencyNameEn: 'Indonesian rupiah',
    tinType: 'NPWP',
    tinName: 'Nomor Pokok Wajib Pajak',
    countryCallingCode: '62',
    region: 'Asia & Pacific',
    flag: '🇮🇩',
  },
  {
    countryNameEn: 'Ireland',
    countryNameLocal: 'Ireland, Éire',
    countryCode: 'IE',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'VAT or CBL',
    tinName: 'Value added tax identification no.',
    countryCallingCode: '353',
    region: 'Europe',
    flag: '🇮🇪',
  },
  {
    countryNameEn: 'Israel',
    countryNameLocal: 'ישראל',
    countryCode: 'IL',
    currencyCode: 'ILS',
    currencyNameEn: 'Israeli new shekel',
    tinType: '',
    tinName: 'מס\' עוסק מורשה / ח"פ',
    countryCallingCode: '972',
    region: 'Europe',
    flag: '🇮🇱',
  },
  {
    countryNameEn: 'Isle of Man',
    countryNameLocal: 'Isle of Man',
    countryCode: 'IM',
    currencyCode: 'GBP',
    currencyNameEn: 'Pound sterling',
    tinType: '',
    tinName: '',
    countryCallingCode: '44',
    region: 'Europe',
    flag: '🇮🇲',
  },
  {
    countryNameEn: 'India',
    countryNameLocal: 'भारत, India',
    countryCode: 'IN',
    currencyCode: 'INR',
    currencyNameEn: 'Indian rupee',
    tinType: 'VAT TIN / CST TIN',
    tinName:
      'Value Added Tax - Taxpayer Identification Number / Central Sales Tax - Taxpayer Identification Number (In most states)Not applicable',
    countryCallingCode: '91',
    region: 'Asia & Pacific',
    flag: '🇮🇳',
  },
  {
    countryNameEn: 'Iraq',
    countryNameLocal: 'العراق, Iraq',
    countryCode: 'IQ',
    currencyCode: 'IQD',
    currencyNameEn: 'Iraqi dinar',
    tinType: '',
    tinName: '',

    countryCallingCode: '964',
    region: 'Arab States',
    flag: '🇮🇶',
  },
  {
    countryNameEn: 'Iran (Islamic Republic of)',
    countryNameLocal: 'ایران',
    countryCode: 'IR',
    currencyCode: 'IRR',
    currencyNameEn: 'Iranian rial',
    tinType: '',
    tinName: '',
    countryCallingCode: '98',
    region: 'Asia & Pacific',
    flag: '🇮🇷',
  },
  {
    countryNameEn: 'Iceland',
    countryNameLocal: 'Ísland',
    countryCode: 'IS',
    currencyCode: 'ISK',
    currencyNameEn: 'Icelandic króna',
    tinType: 'VSK / VASK',
    tinName: 'Virðisaukaskattsnúmer',
    countryCallingCode: '354',
    region: 'Europe',
    flag: '🇮🇸',
  },
  {
    countryNameEn: 'Italy',
    countryNameLocal: 'Italia',
    countryCode: 'IT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'P.IVA',
    tinName: 'Partita IVA(IVA = Imposta sul Valore Aggiunto)',

    countryCallingCode: '39',
    region: 'Europe',
    flag: '🇮🇹',
  },
  {
    countryNameEn: 'Jersey',
    countryNameLocal: 'Jersey',
    countryCode: 'JE',
    currencyCode: 'GBP',
    currencyNameEn: 'Pound sterling',
    tinType: '',
    tinName: '',
    countryCallingCode: '44',
    region: 'Europe',
    flag: '🇯🇪',
  },
  {
    countryNameEn: 'Jamaica',
    countryNameLocal: 'Jamaica',
    countryCode: 'JM',
    currencyCode: 'JMD',
    currencyNameEn: 'Jamaican dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '876',
    region: 'South/Latin America',
    flag: '🇯🇲',
  },
  {
    countryNameEn: 'Jordan',
    countryNameLocal: 'الأُرْدُن',
    countryCode: 'JO',
    currencyCode: 'JOD',
    currencyNameEn: 'Jordanian dinar',
    tinType: '',
    tinName: '',

    countryCallingCode: '962',
    region: 'Arab States',
    flag: '🇯🇴',
  },
  {
    countryNameEn: 'Japan',
    countryNameLocal: '日本',
    countryCode: 'JP',
    currencyCode: 'JPY',
    currencyNameEn: 'Japanese yen',
    tinType: '',
    tinName: '',
    countryCallingCode: '81',
    region: 'Asia & Pacific',
    flag: '🇯🇵',
  },
  {
    countryNameEn: 'Kenya',
    countryNameLocal: 'Kenya',
    countryCode: 'KE',
    currencyCode: 'KES',
    currencyNameEn: 'Kenyan shilling',
    tinType: '',
    tinName: '',
    countryCallingCode: '254',
    region: 'Africa',
    flag: '🇰🇪',
  },
  {
    countryNameEn: 'Kyrgyzstan',
    countryNameLocal: 'Кыргызстан, Киргизия',
    countryCode: 'KG',
    currencyCode: 'KGS',
    currencyNameEn: 'Kyrgyzstani som',
    tinType: '',
    tinName: '',
    countryCallingCode: '996',
    region: 'Asia & Pacific',
    flag: '🇰🇬',
  },
  {
    countryNameEn: 'Cambodia',
    countryNameLocal: 'កម្ពុជា',
    countryCode: 'KH',
    currencyCode: 'KHR',
    currencyNameEn: 'Cambodian riel',
    tinType: '',
    tinName: '',
    countryCallingCode: '855',
    region: 'Asia & Pacific',
    flag: '🇰🇭',
  },
  {
    countryNameEn: 'North Korea',
    countryNameLocal: '조선민주주의인민공화국',
    countryCode: 'KP',
    currencyCode: 'KPW',
    currencyNameEn: 'North Korean won',
    tinType: '',
    tinName: '',
    countryCallingCode: '850',
    region: 'Asia',
    flag: '🇰🇵',
  },
  {
    countryNameEn: 'South Korea',
    countryNameLocal: '대한민국',
    countryCode: 'KR',
    currencyCode: 'KRW',
    currencyNameEn: 'South Korean won',
    tinType: '',
    tinName: '',
    countryCallingCode: '82',
    region: 'Asia',
    flag: '🇰🇷',
  },
  {
    countryNameEn: 'Kiribati',
    countryNameLocal: 'Kiribati',
    countryCode: 'KI',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '686',
    region: 'Asia & Pacific',
    flag: '🇰🇮',
  },
  {
    countryNameEn: 'Saint Kitts and Nevis',
    countryNameLocal: 'Saint Kitts and Nevis',
    countryCode: 'KN',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1869',
    region: 'South/Latin America',
    flag: '🇰🇳',
  },
  {
    countryNameEn: 'Kuwait',
    countryNameLocal: 'الكويت',
    countryCode: 'KW',
    currencyCode: 'KWD',
    currencyNameEn: 'Kuwaiti dinar',
    tinType: '',
    tinName: '',

    countryCallingCode: '965',
    region: 'Arab States',
    flag: '🇰🇼',
  },
  {
    countryNameEn: 'Kazakhstan',
    countryNameLocal: 'Қазақстан, Казахстан',
    countryCode: 'KZ',
    currencyCode: 'KZT',
    currencyNameEn: 'Kazakhstani tenge',
    tinType: '',
    tinName: '',
    countryCallingCode: '7',
    region: 'Asia & Pacific',
    flag: '🇰🇿',
  },
  {
    countryNameEn: 'Lebanon',
    countryNameLocal: 'لبنان, Liban',
    countryCode: 'LB',
    currencyCode: 'LBP',
    currencyNameEn: 'Lebanese pound',
    tinType: '',
    tinName: '',

    countryCallingCode: '961',
    region: 'Arab States',
    flag: '🇱🇧',
  },
  {
    countryNameEn: 'Saint Lucia',
    countryNameLocal: 'Saint Lucia',
    countryCode: 'LC',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1758',
    region: 'South/Latin America',
    flag: '🇱🇨',
  },
  {
    countryNameEn: 'Liechtenstein',
    countryNameLocal: 'Liechtenstein',
    countryCode: 'LI',
    currencyCode: 'CHF',
    currencyNameEn: 'Swiss franc',
    tinType: '',
    tinName: '',

    countryCallingCode: '423',
    region: 'Europe',
    flag: '🇱🇮',
  },
  {
    countryNameEn: 'Sri Lanka',
    countryNameLocal: 'ශ්‍රී ලංකා, இலங்கை',
    countryCode: 'LK',
    currencyCode: 'LKR',
    currencyNameEn: 'Sri Lankan rupee',
    tinType: '',
    tinName: '',
    countryCallingCode: '94',
    region: 'Asia & Pacific',
    flag: '🇱🇰',
  },
  {
    countryNameEn: 'Liberia',
    countryNameLocal: 'Liberia',
    countryCode: 'LR',
    currencyCode: 'LRD',
    currencyNameEn: 'Liberian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '231',
    region: 'Africa',
    flag: '🇱🇷',
  },
  {
    countryNameEn: 'Lesotho',
    countryNameLocal: 'Lesotho',
    countryCode: 'LS',
    currencyCode: 'LSL',
    currencyNameEn: 'Lesotho loti',
    tinType: '',
    tinName: '',
    countryCallingCode: '266',
    region: 'Africa',
    flag: '🇱🇸',
  },
  {
    countryNameEn: 'Lithuania',
    countryNameLocal: 'Lietuva',
    countryCode: 'LT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'PVM kodas',
    tinName: 'PVM (abbrev. Pridėtinės vertės mokestis) mokėtojo kodas',
    countryCallingCode: '370',
    region: 'Europe',
    flag: '🇱🇹',
  },
  {
    countryNameEn: 'Luxembourg',
    countryNameLocal: 'Lëtzebuerg, Luxembourg, Luxemburg',
    countryCode: 'LU',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'No. TVA',
    tinName: "Numéro d'identification à la taxe sur la valeur ajoutée",
    countryCallingCode: '352',
    region: 'Europe',
    flag: '🇱🇺',
  },
  {
    countryNameEn: 'Latvia',
    countryNameLocal: 'Latvija',
    countryCode: 'LV',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'PVN',
    tinName: 'Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs',
    countryCallingCode: '371',
    region: 'Europe',
    flag: '🇱🇻',
  },
  {
    countryNameEn: 'Libya',
    countryNameLocal: 'ليبيا',
    countryCode: 'LY',
    currencyCode: 'LYD',
    currencyNameEn: 'Libyan dinar',
    tinType: '',
    tinName: '',

    countryCallingCode: '218',
    region: 'Arab States',
    flag: '🇱🇾',
  },
  {
    countryNameEn: 'Morocco',
    countryNameLocal: 'Maroc, ⵍⵎⵖⵔⵉⴱ, المغرب',
    countryCode: 'MA',
    currencyCode: 'MAD',
    currencyNameEn: 'Moroccan dirham',
    tinType: '',
    tinName: '',

    countryCallingCode: '212',
    region: 'Arab States',
    flag: '🇲🇦',
  },
  {
    countryNameEn: 'Monaco',
    countryNameLocal: 'Monaco',
    countryCode: 'MC',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',

    countryCallingCode: '377',
    region: 'Europe',
    flag: '🇲🇨',
  },
  {
    countryNameEn: 'Montenegro',
    countryNameLocal: 'Crna Gora, Црна Гора',
    countryCode: 'ME',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    countryCallingCode: '382',
    region: 'Europe',
    flag: '🇲🇪',
  },
  {
    countryNameEn: 'Saint Martin (French part)',
    countryNameLocal: 'Saint-Martin',
    countryCode: 'MF',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',

    countryCallingCode: '590',
    region: 'South/Latin America',
    flag: '🇲🇫',
  },
  {
    countryNameEn: 'Madagascar',
    countryNameLocal: 'Madagasikara, Madagascar',
    countryCode: 'MG',
    currencyCode: 'MGA',
    currencyNameEn: 'Malagasy ariary',
    tinType: '',
    tinName: '',
    countryCallingCode: '261',
    region: 'Africa',
    flag: '🇲🇬',
  },
  {
    countryNameEn: 'Mali',
    countryNameLocal: 'Mali',
    countryCode: 'ML',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',

    countryCallingCode: '223',
    region: 'Africa',
    flag: '🇲🇱',
  },
  {
    countryNameEn: 'Myanmar',
    countryNameLocal: 'မြန်မာ',
    countryCode: 'MM',
    currencyCode: 'MMK',
    currencyNameEn: 'Myanmar kyat',
    tinType: '',
    tinName: '',
    countryCallingCode: '95',
    region: 'Asia & Pacific',
    flag: '🇲🇲',
  },
  {
    countryNameEn: 'Mongolia',
    countryNameLocal: 'Монгол Улс',
    countryCode: 'MN',
    currencyCode: 'MNT',
    currencyNameEn: 'Mongolian tögrög',
    tinType: '',
    tinName: '',
    countryCallingCode: '976',
    region: 'Asia & Pacific',
    flag: '🇲🇳',
  },
  {
    countryNameEn: 'Macao',
    countryNameLocal: '澳門, Macau',
    countryCode: 'MO',
    currencyCode: 'MOP',
    currencyNameEn: 'Macanese pataca',
    tinType: '',
    tinName: '',
    countryCallingCode: '853',
    region: 'Asia & Pacific',
    flag: '🇲🇴',
  },
  {
    countryNameEn: 'Martinique',
    countryNameLocal: 'Martinique',
    countryCode: 'MQ',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',

    countryCallingCode: '596',
    region: 'South/Latin America',
    flag: '🇲🇶',
  },
  {
    countryNameEn: 'Mauritania',
    countryNameLocal: 'موريتانيا, Mauritanie',
    countryCode: 'MR',
    currencyCode: 'MRU',
    currencyNameEn: '',
    tinType: '',
    tinName: '',

    countryCallingCode: '222',
    region: 'Arab States',
    flag: '🇲🇷',
  },
  {
    countryNameEn: 'Montserrat',
    countryNameLocal: 'Montserrat',
    countryCode: 'MS',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1664',
    region: 'South/Latin America',
    flag: '🇲🇸',
  },
  {
    countryNameEn: 'Malta',
    countryNameLocal: 'Malta',
    countryCode: 'MT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'Vat No.',
    tinName: 'Vat reg. no.',
    countryCallingCode: '356',
    region: 'Europe',
    flag: '🇲🇹',
  },
  {
    countryNameEn: 'Mauritius',
    countryNameLocal: 'Maurice, Mauritius',
    countryCode: 'MU',
    currencyCode: 'MUR',
    currencyNameEn: 'Mauritian rupee',
    tinType: '',
    tinName: '',
    countryCallingCode: '230',
    region: 'Africa',
    flag: '🇲🇺',
  },
  {
    countryNameEn: 'Maldives',
    countryNameLocal: '',
    countryCode: 'MV',
    currencyCode: 'MVR',
    currencyNameEn: 'Maldivian rufiyaa',
    tinType: '',
    tinName: '',
    countryCallingCode: '960',
    region: 'Asia & Pacific',
    flag: '🇲🇻',
  },
  {
    countryNameEn: 'Malawi',
    countryNameLocal: 'Malawi',
    countryCode: 'MW',
    currencyCode: 'MWK',
    currencyNameEn: 'Malawian kwacha',
    tinType: '',
    tinName: '',
    countryCallingCode: '265',
    region: 'Africa',
    flag: '🇲🇼',
  },
  {
    countryNameEn: 'Mexico',
    countryNameLocal: 'México',
    countryCode: 'MX',
    currencyCode: 'MXN',
    currencyNameEn: 'Mexican peso',
    tinType: 'RFC',
    tinName: 'Registro Federal de Contribuyentes',

    countryCallingCode: '52',
    region: 'South/Latin America',
    flag: '🇲🇽',
  },
  {
    countryNameEn: 'Malaysia',
    countryNameLocal: '',
    countryCode: 'MY',
    currencyCode: 'MYR',
    currencyNameEn: 'Malaysian ringgit',
    tinType: '',
    tinName: '',
    countryCallingCode: '60',
    region: 'Asia & Pacific',
    flag: '🇲🇾',
  },
  {
    countryNameEn: 'Mozambique',
    countryNameLocal: 'Mozambique',
    countryCode: 'MZ',
    currencyCode: 'MZN',
    currencyNameEn: 'Mozambican metical',
    tinType: '',
    tinName: '',

    countryCallingCode: '258',
    region: 'Africa',
    flag: '🇲🇿',
  },
  {
    countryNameEn: 'Namibia',
    countryNameLocal: 'Namibia',
    countryCode: 'NA',
    currencyCode: 'NAD',
    currencyNameEn: 'Namibian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '264',
    region: 'Africa',
    flag: '🇳🇦',
  },
  {
    countryNameEn: 'New Caledonia',
    countryNameLocal: 'Nouvelle-Calédonie',
    countryCode: 'NC',
    currencyCode: 'XPF',
    currencyNameEn: 'CFP franc (franc Pacifique)',
    tinType: '',
    tinName: '',

    countryCallingCode: '687',
    region: 'Asia & Pacific',
    flag: '🇳🇨',
  },
  {
    countryNameEn: 'Norfolk Island',
    countryNameLocal: 'Norfolk Island',
    countryCode: 'NF',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '672',
    region: 'Asia & Pacific',
    flag: '🇳🇫',
  },
  {
    countryNameEn: 'Nigeria',
    countryNameLocal: 'Nigeria',
    countryCode: 'NG',
    currencyCode: 'NGN',
    currencyNameEn: 'Nigerian naira',
    tinType: '',
    tinName: '',
    countryCallingCode: '234',
    region: 'Africa',
    flag: '🇳🇬',
  },
  {
    countryNameEn: 'Nicaragua',
    countryNameLocal: 'Nicaragua',
    countryCode: 'NI',
    currencyCode: 'NIO',
    currencyNameEn: 'Nicaraguan córdoba',
    tinType: 'RUC',
    tinName: 'Registro Unico de Contribuyentes',

    countryCallingCode: '505',
    region: 'South/Latin America',
    flag: '🇳🇮',
  },
  {
    countryNameEn: 'Norway',
    countryNameLocal: 'Norge, Noreg',
    countryCode: 'NO',
    currencyCode: 'NOK',
    currencyNameEn: 'Norwegian krone',
    tinType: 'Orgnr',
    tinName: 'Organisasjonsnummer',
    countryCallingCode: '47',
    region: 'Europe',
    flag: '🇳🇴',
  },
  {
    countryNameEn: 'Nepal',
    countryNameLocal: '',
    countryCode: 'NP',
    currencyCode: 'NPR',
    currencyNameEn: 'Nepalese rupee',
    tinType: '',
    tinName: '',
    countryCallingCode: '977',
    region: 'Asia & Pacific',
    flag: '🇳🇵',
  },
  {
    countryNameEn: 'Nauru',
    countryNameLocal: 'Nauru',
    countryCode: 'NR',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '674',
    region: 'Asia & Pacific',
    flag: '🇳🇷',
  },
  {
    countryNameEn: 'Niue',
    countryNameLocal: 'Niue',
    countryCode: 'NU',
    currencyCode: 'NZD',
    currencyNameEn: 'New Zealand dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '683',
    region: 'Asia & Pacific',
    flag: '🇳🇺',
  },
  {
    countryNameEn: 'New Zealand',
    countryNameLocal: 'New Zealand',
    countryCode: 'NZ',
    currencyCode: 'NZD',
    currencyNameEn: 'New Zealand dollar',
    tinType: 'NZBN',
    tinName: 'NZ Business Number',
    countryCallingCode: '64',
    region: 'Asia & Pacific',
    flag: '🇳🇿',
  },
  {
    countryNameEn: 'Oman',
    countryNameLocal: 'سلطنة عُمان',
    countryCode: 'OM',
    currencyCode: 'OMR',
    currencyNameEn: 'Omani rial',
    tinType: '',
    tinName: '',

    countryCallingCode: '968',
    region: 'Arab States',
    flag: '🇴🇲',
  },
  {
    countryNameEn: 'Panama',
    countryNameLocal: 'Panama',
    countryCode: 'PA',
    currencyCode: 'PAB',
    currencyNameEn: 'Panamanian balboa',
    tinType: 'RUC',
    tinName: 'Registro Unico de Contribuyentes',

    countryCallingCode: '507',
    region: 'South/Latin America',
    flag: '🇵🇦',
  },
  {
    countryNameEn: 'Peru',
    countryNameLocal: 'Perú',
    countryCode: 'PE',
    currencyCode: 'PEN',
    currencyNameEn: 'Peruvian sol',
    tinType: 'RUC',
    tinName: 'Registro Unico de Contribuyentes',

    countryCallingCode: '51',
    region: 'South/Latin America',
    flag: '🇵🇪',
  },
  {
    countryNameEn: 'French Polynesia',
    countryNameLocal: 'Polynésie française',
    countryCode: 'PF',
    currencyCode: 'XPF',
    currencyNameEn: 'CFP franc (franc Pacifique)',
    tinType: '',
    tinName: '',

    countryCallingCode: '689',
    region: 'Asia & Pacific',
    flag: '🇵🇫',
  },
  {
    countryNameEn: 'Papua New Guinea',
    countryNameLocal: 'Papua New Guinea',
    countryCode: 'PG',
    currencyCode: 'PGK',
    currencyNameEn: 'Papua New Guinean kina',
    tinType: '',
    tinName: '',
    countryCallingCode: '675',
    region: 'Asia & Pacific',
    flag: '🇵🇬',
  },
  {
    countryNameEn: 'Pakistan',
    countryNameLocal: 'پاکستان',
    countryCode: 'PK',
    currencyCode: 'PKR',
    currencyNameEn: 'Pakistani rupee',
    tinType: '',
    tinName: '',
    countryCallingCode: '92',
    region: 'Asia & Pacific',
    flag: '🇵🇰',
  },
  {
    countryNameEn: 'Poland',
    countryNameLocal: 'Polska',
    countryCode: 'PL',
    currencyCode: 'PLN',
    currencyNameEn: 'Polish złoty',
    tinType: 'NIP',
    tinName: 'numer identyfikacji podatkowej',
    countryCallingCode: '48',
    region: 'Europe',
    flag: '🇵🇱',
  },
  {
    countryNameEn: 'Saint Pierre and Miquelon',
    countryNameLocal: 'Saint-Pierre-et-Miquelon',
    countryCode: 'PM',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',

    countryCallingCode: '508',
    region: 'North America',
    flag: '🇵🇲',
  },
  {
    countryNameEn: 'Pitcairn',
    countryNameLocal: 'Pitcairn',
    countryCode: 'PN',
    currencyCode: 'NZD',
    currencyNameEn: 'New Zealand dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '64',
    region: 'Asia & Pacific',
    flag: '🇵🇳',
  },
  {
    countryNameEn: 'Puerto Rico',
    countryNameLocal: 'Puerto Rico',
    countryCode: 'PR',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',

    countryCallingCode: '1',
    region: 'South/Latin America',
    flag: '🇵🇷',
  },
  {
    countryNameEn: 'Palestine, State of',
    countryNameLocal: 'Palestinian Territory',
    countryCode: 'PS',
    currencyCode: '',
    currencyNameEn: '',
    tinType: '',
    tinName: '',

    countryCallingCode: '970',
    region: 'Arab States',
    flag: '🇵🇸',
  },
  {
    countryNameEn: 'Portugal',
    countryNameLocal: 'Portugal',
    countryCode: 'PT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'NIPC',
    tinName: 'Número de Identificação de Pessoa Coletiva (NIPC)',

    countryCallingCode: '351',
    region: 'Europe',
    flag: '🇵🇹',
  },
  {
    countryNameEn: 'Palau',
    countryNameLocal: 'Palau',
    countryCode: 'PW',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '680',
    region: 'Asia & Pacific',
    flag: '🇵🇼',
  },
  {
    countryNameEn: 'Paraguay',
    countryNameLocal: 'Paraguay',
    countryCode: 'PY',
    currencyCode: 'PYG',
    currencyNameEn: 'Paraguayan guaraní',
    tinType: 'RUC',
    tinName: 'Registro Unico de Contribuyentes',

    countryCallingCode: '595',
    region: 'South/Latin America',
    flag: '🇵🇾',
  },
  {
    countryNameEn: 'Qatar',
    countryNameLocal: 'قطر',
    countryCode: 'QA',
    currencyCode: 'QAR',
    currencyNameEn: 'Qatari riyal',
    tinType: '',
    tinName: '',

    countryCallingCode: '974',
    region: 'Arab States',
    flag: '🇶🇦',
  },
  {
    countryNameEn: 'Réunion',
    countryNameLocal: 'La Réunion',
    countryCode: 'RE',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',

    countryCallingCode: '262',
    region: 'Asia & Pacific',
    flag: '🇷🇪',
  },
  {
    countryNameEn: 'Romania',
    countryNameLocal: 'România',
    countryCode: 'RO',
    currencyCode: 'RON',
    currencyNameEn: 'Romanian leu',
    tinType: 'CIF',
    tinName: 'Codul de identificare fiscală',
    countryCallingCode: '40',
    region: 'Europe',
    flag: '🇷🇴',
  },
  {
    countryNameEn: 'Serbia',
    countryNameLocal: 'Србија',
    countryCode: 'RS',
    currencyCode: 'RSD',
    currencyNameEn: 'Serbian dinar',
    tinType: 'PIB',
    tinName: 'Poreski identifikacioni broj',
    countryCallingCode: '381',
    region: 'Europe',
    flag: '🇷🇸',
  },
  {
    countryNameEn: 'Russia',
    countryNameLocal: 'Россия',
    countryCode: 'RU',
    currencyCode: 'RUB',
    currencyNameEn: 'Russian ruble',
    tinType: 'ИНН',
    tinName: 'Идентификационный номер налогоплательщика',
    countryCallingCode: '7',
    region: 'Europe',
    flag: '🇷🇺',
  },
  {
    countryNameEn: 'Rwanda',
    countryNameLocal: 'Rwanda',
    countryCode: 'RW',
    currencyCode: 'RWF',
    currencyNameEn: 'Rwandan franc',
    tinType: '',
    tinName: '',
    countryCallingCode: '250',
    region: 'Africa',
    flag: '🇷🇼',
  },
  {
    countryNameEn: 'Saudi Arabia',
    countryNameLocal: 'السعودية',
    countryCode: 'SA',
    currencyCode: 'SAR',
    currencyNameEn: 'Saudi riyal',
    tinType: '',
    tinName: '',

    countryCallingCode: '966',
    region: 'Arab States',
    flag: '🇸🇦',
  },
  {
    countryNameEn: 'Solomon Islands',
    countryNameLocal: 'Solomon Islands',
    countryCode: 'SB',
    currencyCode: 'SBD',
    currencyNameEn: 'Solomon Islands dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '677',
    region: 'Asia & Pacific',
    flag: '🇸🇧',
  },
  {
    countryNameEn: 'Seychelles',
    countryNameLocal: 'Seychelles',
    countryCode: 'SC',
    currencyCode: 'SCR',
    currencyNameEn: 'Seychelles rupee',
    tinType: '',
    tinName: '',

    countryCallingCode: '248',
    region: 'Africa',
    flag: '🇸🇨',
  },
  {
    countryNameEn: 'Sweden',
    countryNameLocal: 'Sverige',
    countryCode: 'SE',
    currencyCode: 'SEK',
    currencyNameEn: 'Swedish krona/kronor',
    tinType: 'Momsnr.',
    tinName: 'VAT-nummer',
    countryCallingCode: '46',
    region: 'Europe',
    flag: '🇸🇪',
  },
  {
    countryNameEn: 'Singapore',
    countryNameLocal: 'Singapore',
    countryCode: 'SG',
    currencyCode: 'SGD',
    currencyNameEn: 'Singapore dollar',
    tinType: '',
    tinName: '',

    countryCallingCode: '65',
    region: 'Asia & Pacific',
    flag: '🇸🇬',
  },
  {
    countryNameEn: 'Saint Helena, Ascension and Tristan da Cunha',
    countryNameLocal: 'Saint Helena',
    countryCode: 'SH',
    currencyCode: 'SHP',
    currencyNameEn: 'Saint Helena pound',
    tinType: '',
    tinName: '',
    countryCallingCode: '290',
    region: 'Africa',
    flag: '🇸🇭',
  },
  {
    countryNameEn: 'Slovenia',
    countryNameLocal: 'Slovenija',
    countryCode: 'SI',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'ID za DDV',
    tinName: 'Davčna številka',
    countryCallingCode: '386',
    region: 'Europe',
    flag: '🇸🇮',
  },
  {
    countryNameEn: 'Svalbard and Jan Mayen',
    countryNameLocal: 'Svalbard and Jan Mayen',
    countryCode: 'SJ',
    currencyCode: 'NOK',
    currencyNameEn: 'Norwegian krone',
    tinType: '',
    tinName: '',
    countryCallingCode: '4779',
    region: 'Europe',
    flag: '🇸🇯',
  },
  {
    countryNameEn: 'Slovakia',
    countryNameLocal: 'Slovensko',
    countryCode: 'SK',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'IČ DPH',
    tinName: 'Identifikačné číslo pre daň z pridanej hodnoty',
    countryCallingCode: '421',
    region: 'Europe',
    flag: '🇸🇰',
  },
  {
    countryNameEn: 'Sierra Leone',
    countryNameLocal: 'Sierra Leone',
    countryCode: 'SL',
    currencyCode: 'SLL',
    currencyNameEn: 'Sierra Leonean leone',
    tinType: '',
    tinName: '',
    countryCallingCode: '232',
    region: 'Africa',
    flag: '🇸🇱',
  },
  {
    countryNameEn: 'San Marino',
    countryNameLocal: 'San Marino',
    countryCode: 'SM',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'C.O.E.',
    tinName: 'Codice operatore economico',

    countryCallingCode: '378',
    region: 'Europe',
    flag: '🇸🇲',
  },
  {
    countryNameEn: 'Senegal',
    countryNameLocal: 'Sénégal',
    countryCode: 'SN',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',

    countryCallingCode: '221',
    region: 'Africa',
    flag: '🇸🇳',
  },
  {
    countryNameEn: 'Somalia',
    countryNameLocal: 'Somalia, الصومال',
    countryCode: 'SO',
    currencyCode: 'SOS',
    currencyNameEn: 'Somali shilling',
    tinType: '',
    tinName: '',
    countryCallingCode: '252',
    region: 'Arab States',
    flag: '🇸🇴',
  },
  {
    countryNameEn: 'Suriname',
    countryNameLocal: 'Suriname',
    countryCode: 'SR',
    currencyCode: 'SRD',
    currencyNameEn: 'Surinamese dollar',
    tinType: '',
    tinName: '',

    countryCallingCode: '597',
    region: 'South/Latin America',
    flag: '🇸🇷',
  },
  {
    countryNameEn: 'South Sudan',
    countryNameLocal: 'South Sudan',
    countryCode: 'SS',
    currencyCode: 'SSP',
    currencyNameEn: 'South Sudanese pound',
    tinType: '',
    tinName: '',
    countryCallingCode: '211',
    region: 'Africa',
    flag: '🇸🇸',
  },
  {
    countryNameEn: 'Sao Tome and Principe',
    countryNameLocal: 'São Tomé e Príncipe',
    countryCode: 'ST',
    currencyCode: 'STN',
    currencyNameEn: '',
    tinType: '',
    tinName: '',

    countryCallingCode: '239',
    region: 'Africa',
    flag: '🇸🇹',
  },
  {
    countryNameEn: 'El Salvador',
    countryNameLocal: 'El Salvador',
    countryCode: 'SV',
    currencyCode: 'SVC',
    currencyNameEn: 'Salvadoran colón',
    tinType: 'NIT',
    tinName: 'Número de Identificación Tributaria',

    countryCallingCode: '503',
    region: 'South/Latin America',
    flag: '🇸🇻',
  },
  {
    countryNameEn: 'Sint Maarten (Dutch part)',
    countryNameLocal: 'Sint Maarten',
    countryCode: 'SX',
    currencyCode: 'ANG',
    currencyNameEn: 'Netherlands Antillean guilder',
    tinType: '',
    tinName: '',

    countryCallingCode: '1721',
    region: 'Unknown',
    flag: '🇸🇽',
  },
  {
    countryNameEn: 'Syrian Arab Republic',
    countryNameLocal: 'سوريا, Sūriyya',
    countryCode: 'SY',
    currencyCode: 'SYP',
    currencyNameEn: 'Syrian pound',
    tinType: '',
    tinName: '',

    countryCallingCode: '963',
    region: 'Asia & Pacific',
    flag: '🇸🇾',
  },
  {
    countryNameEn: 'Chad',
    countryNameLocal: 'Tchad, تشاد',
    countryCode: 'TD',
    currencyCode: 'XAF',
    currencyNameEn: 'CFA franc BEAC',
    tinType: '',
    tinName: '',

    countryCallingCode: '235',
    region: 'Africa',
    flag: '🇹🇩',
  },
  {
    countryNameEn: 'Togo',
    countryNameLocal: 'Togo',
    countryCode: 'TG',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',

    countryCallingCode: '228',
    region: 'Africa',
    flag: '🇹🇬',
  },
  {
    countryNameEn: 'Thailand',
    countryNameLocal: 'ประเทศไทย',
    countryCode: 'TH',
    currencyCode: 'THB',
    currencyNameEn: 'Thai baht',
    tinType: '',
    tinName: '',
    countryCallingCode: '66',
    region: 'Asia & Pacific',
    flag: '🇹🇭',
  },
  {
    countryNameEn: 'Tajikistan',
    countryNameLocal: ',',
    countryCode: 'TJ',
    currencyCode: 'TJS',
    currencyNameEn: 'Tajikistani somoni',
    tinType: '',
    tinName: '',
    countryCallingCode: '992',
    region: 'Asia & Pacific',
    flag: '🇹🇯',
  },
  {
    countryNameEn: 'Tokelau',
    countryNameLocal: 'Tokelau',
    countryCode: 'TK',
    currencyCode: 'NZD',
    currencyNameEn: 'New Zealand dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '690',
    region: 'Asia & Pacific',
    flag: '🇹🇰',
  },
  {
    countryNameEn: 'Timor-Leste',
    countryNameLocal: "Timor-Leste, Timor Lorosa'e",
    countryCode: 'TL',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',

    countryCallingCode: '670',
    region: 'Asia & Pacific',
    flag: '🇹🇱',
  },
  {
    countryNameEn: 'Turkmenistan',
    countryNameLocal: 'Türkmenistan',
    countryCode: 'TM',
    currencyCode: 'TMT',
    currencyNameEn: 'Turkmenistan manat',
    tinType: '',
    tinName: '',
    countryCallingCode: '993',
    region: 'Asia & Pacific',
    flag: '🇹🇲',
  },
  {
    countryNameEn: 'Tunisia',
    countryNameLocal: 'تونس, Tunisie',
    countryCode: 'TN',
    currencyCode: 'TND',
    currencyNameEn: 'Tunisian dinar',
    tinType: '',
    tinName: '',

    countryCallingCode: '216',
    region: 'Arab States',
    flag: '🇹🇳',
  },
  {
    countryNameEn: 'Tonga',
    countryNameLocal: 'Tonga',
    countryCode: 'TO',
    currencyCode: 'TOP',
    currencyNameEn: 'Tongan paʻanga',
    tinType: '',
    tinName: '',
    countryCallingCode: '676',
    region: 'Asia & Pacific',
    flag: '🇹🇴',
  },
  {
    countryNameEn: 'Turkey',
    countryNameLocal: 'Türkiye',
    countryCode: 'TR',
    currencyCode: 'TRY',
    currencyNameEn: 'Turkish lira',
    tinType: 'KDV',
    tinName: 'Vergi Kimlik Numarası',
    countryCallingCode: '90',
    region: 'Europe',
    flag: '🇹🇷',
  },
  {
    countryNameEn: 'Trinidad and Tobago',
    countryNameLocal: 'Trinidad and Tobago',
    countryCode: 'TT',
    currencyCode: 'TTD',
    currencyNameEn: 'Trinidad and Tobago dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '868',
    region: 'South/Latin America',
    flag: '🇹🇹',
  },
  {
    countryNameEn: 'Tuvalu',
    countryNameLocal: 'Tuvalu',
    countryCode: 'TV',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '688',
    region: 'Asia & Pacific',
    flag: '🇹🇻',
  },
  {
    countryNameEn: 'United Republic of Tanzania',
    countryNameLocal: 'Tanzania',
    countryCode: 'TZ',
    currencyCode: 'TZS',
    currencyNameEn: 'Tanzanian shilling',
    tinType: '',
    tinName: '',
    countryCallingCode: '255',
    region: 'Africa',
    flag: '🇹🇿',
  },
  {
    countryNameEn: 'Ukraine',
    countryNameLocal: 'Україна',
    countryCode: 'UA',
    currencyCode: 'UAH',
    currencyNameEn: 'Ukrainian hryvnia',
    tinType: 'ІНПП',
    tinName: 'Ідентифікаційний номер платника податків',
    countryCallingCode: '380',
    region: 'Europe',
    flag: '🇺🇦',
  },
  {
    countryNameEn: 'Uganda',
    countryNameLocal: 'Uganda',
    countryCode: 'UG',
    currencyCode: 'UGX',
    currencyNameEn: 'Ugandan shilling',
    tinType: '',
    tinName: '',
    countryCallingCode: '256',
    region: 'Africa',
    flag: '🇺🇬',
  },
  {
    countryNameEn: 'United States of America',
    countryNameLocal: 'United States of America',
    countryCode: 'US',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: 'EIN',
    tinName: 'Tax Identification Number',
    countryCallingCode: '1',
    region: 'North America',
    flag: '🇺🇸',
  },
  {
    countryNameEn: 'Uruguay',
    countryNameLocal: 'Uruguay',
    countryCode: 'UY',
    currencyCode: 'UYU',
    currencyNameEn: 'Uruguayan peso',
    tinType: 'RUT',
    tinName: 'Registro Único Tributario',

    countryCallingCode: '598',
    region: 'South/Latin America',
    flag: '🇺🇾',
  },
  {
    countryNameEn: 'Uzbekistan',
    countryNameLocal: '',
    countryCode: 'UZ',
    currencyCode: 'UZS',
    currencyNameEn: 'Uzbekistan som',
    tinType: 'СТИР',
    tinName: 'Солиқ тўловчиларнинг идентификация рақами',
    countryCallingCode: '998',
    region: 'Asia & Pacific',
    flag: '🇺🇿',
  },
  {
    countryNameEn: 'Saint Vincent and the Grenadines',
    countryNameLocal: 'Saint Vincent and the Grenadines',
    countryCode: 'VC',
    currencyCode: 'XCD',
    currencyNameEn: 'East Caribbean dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1784',
    region: 'South/Latin America',
    flag: '🇻🇨',
  },
  {
    countryNameEn: 'Venezuela (Bolivarian Republic of)',
    countryNameLocal: 'Venezuela',
    countryCode: 'VE',
    currencyCode: 'VES',
    currencyNameEn: '',
    tinType: 'RIF',
    tinName: 'Registro de Informacion Fiscal',

    countryCallingCode: '58',
    region: 'South/Latin America',
    flag: '🇻🇪',
  },
  {
    countryNameEn: 'Virgin Islands (British)',
    countryNameLocal: 'British Virgin Islands',
    countryCode: 'VG',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1284',
    region: 'South/Latin America',
    flag: '🇻🇬',
  },
  {
    countryNameEn: 'Virgin Islands (U.S.)',
    countryNameLocal: 'United States Virgin Islands',
    countryCode: 'VI',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1340',
    region: 'South/Latin America',
    flag: '🇻🇮',
  },
  {
    countryNameEn: 'Vietnam',
    countryNameLocal: 'Việt Nam',
    countryCode: 'VN',
    currencyCode: 'VND',
    currencyNameEn: 'Vietnamese đồng',
    tinType: '',
    tinName: '',
    countryCallingCode: '84',
    region: 'Asia & Pacific',
    flag: '🇻🇳',
  },
  {
    countryNameEn: 'Vanuatu',
    countryNameLocal: 'Vanuatu',
    countryCode: 'VU',
    currencyCode: 'VUV',
    currencyNameEn: 'Vanuatu vatu',
    tinType: '',
    tinName: '',
    countryCallingCode: '678',
    region: 'Asia & Pacific',
    flag: '🇻🇺',
  },
  {
    countryNameEn: 'Wallis and Futuna',
    countryNameLocal: 'Wallis-et-Futuna',
    countryCode: 'WF',
    currencyCode: 'XPF',
    currencyNameEn: 'CFP franc (franc Pacifique)',
    tinType: '',
    tinName: '',

    countryCallingCode: '681',
    region: 'Asia & Pacific',
    flag: '🇼🇫',
  },
  {
    countryNameEn: 'Samoa',
    countryNameLocal: 'Samoa',
    countryCode: 'WS',
    currencyCode: 'WST',
    currencyNameEn: 'Samoan tala',
    tinType: '',
    tinName: '',
    countryCallingCode: '685',
    region: 'Asia & Pacific',
    flag: '🇼🇸',
  },
  {
    countryNameEn: 'Yemen',
    countryNameLocal: 'اليَمَن',
    countryCode: 'YE',
    currencyCode: 'YER',
    currencyNameEn: 'Yemeni rial',
    tinType: '',
    tinName: '',

    countryCallingCode: '967',
    region: 'Arab States',
    flag: '🇾🇪',
  },
  {
    countryNameEn: 'Mayotte',
    countryNameLocal: 'Mayotte',
    countryCode: 'YT',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',

    countryCallingCode: '262',
    region: 'Africa',
    flag: '🇾🇹',
  },
  {
    countryNameEn: 'South Africa',
    countryNameLocal: 'South Africa',
    countryCode: 'ZA',
    currencyCode: 'ZAR',
    currencyNameEn: 'South African rand',
    tinType: '',
    tinName: '',
    countryCallingCode: '27',
    region: 'Africa',
    flag: '🇿🇦',
  },
  {
    countryNameEn: 'Zambia',
    countryNameLocal: 'Zambia',
    countryCode: 'ZM',
    currencyCode: 'ZMW',
    currencyNameEn: 'Zambian kwacha',
    tinType: '',
    tinName: '',
    countryCallingCode: '260',
    region: 'Africa',
    flag: '🇿🇲',
  },
  {
    countryNameEn: 'Zimbabwe',
    countryNameLocal: 'Zimbabwe',
    countryCode: 'ZW',
    currencyCode: 'ZWL',
    currencyNameEn: 'Zimbabwean dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '263',
    region: 'Africa',
    flag: '🇿🇼',
  },
  {
    countryNameEn: 'Eswatini',
    countryNameLocal: 'Swaziland',
    countryCode: 'SZ',
    currencyCode: 'SZL',
    currencyNameEn: 'Swazi lilangeni',
    tinType: '',
    tinName: '',
    countryCallingCode: '268',
    region: 'Africa',
    flag: '🇸🇿',
  },
  {
    countryNameEn: 'North Macedonia',
    countryNameLocal: 'Македонија',
    countryCode: 'MK',
    currencyCode: 'MKD',
    currencyNameEn: 'Macedonian denar',
    tinType: '',
    tinName: '',
    countryCallingCode: '389',
    region: 'Europe',
    flag: '🇲🇰',
  },
  {
    countryNameEn: 'Philippines',
    countryNameLocal: 'Philippines',
    countryCode: 'PH',
    currencyCode: 'PHP',
    currencyNameEn: 'Philippine peso',
    tinType: 'TIN',
    tinName: 'Tax Identification Number',
    countryCallingCode: '63',
    region: 'Asia & Pacific',
    flag: '🇵🇭',
  },
  {
    countryNameEn: 'Netherlands',
    countryNameLocal: 'Nederland',
    countryCode: 'NL',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: 'Btw-nr.',
    tinName: 'Btw-nummer',

    countryCallingCode: '31',
    region: 'Europe',
    flag: '🇳🇱',
  },
  {
    countryNameEn: 'United Arab Emirates',
    countryNameLocal: 'دولة الإمارات العربيّة المتّحدة',
    countryCode: 'AE',
    currencyCode: 'AED',
    currencyNameEn: 'United Arab Emirates dirham',
    tinType: '',
    tinName: '',

    countryCallingCode: '971',
    region: 'Arab States',
    flag: '🇦🇪',
  },
  {
    countryNameEn: 'Republic of Moldova',
    countryNameLocal: 'Moldova, Молдавия',
    countryCode: 'MD',
    currencyCode: 'MDL',
    currencyNameEn: 'Moldovan leu',
    tinType: '',
    tinName: '',
    countryCallingCode: '373',
    region: 'Europe',
    flag: '🇲🇩',
  },
  {
    countryNameEn: 'Gambia',
    countryNameLocal: 'The Gambia',
    countryCode: 'GM',
    currencyCode: 'GMD',
    currencyNameEn: 'Gambian dalasi',
    tinType: '',
    tinName: '',
    countryCallingCode: '220',
    region: 'Africa',
    flag: '🇬🇲',
  },
  {
    countryNameEn: 'Dominican Republic',
    countryNameLocal: 'República Dominicana',
    countryCode: 'DO',
    currencyCode: 'DOP',
    currencyNameEn: 'Dominican peso',
    tinType: 'RNC',
    tinName: 'Registro Nacional del Contribuyente',

    countryCallingCode: '1',
    region: 'South/Latin America',
    flag: '🇩🇴',
  },
  {
    countryNameEn: 'Sudan',
    countryNameLocal: 'السودان',
    countryCode: 'SD',
    currencyCode: 'SDG',
    currencyNameEn: 'Sudanese pound',
    tinType: '',
    tinName: '',

    countryCallingCode: '249',
    region: 'Arab States',
    flag: '🇸🇩',
  },
  {
    countryNameEn: "Lao People's Democratic Republic",
    countryNameLocal: 'ປະຊາຊົນລາວ',
    countryCode: 'LA',
    currencyCode: 'LAK',
    currencyNameEn: 'Lao kip',
    tinType: '',
    tinName: '',
    countryCallingCode: '856',
    region: 'Asia & Pacific',
    flag: '🇱🇦',
  },
  {
    countryNameEn: 'Taiwan, Province of China',
    countryNameLocal: 'Taiwan',
    countryCode: 'TW',
    currencyCode: 'TWD',
    currencyNameEn: 'New Taiwan dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '886',
    region: 'Asia & Pacific',
    flag: '🇹🇼',
  },
  {
    countryNameEn: 'Republic of the Congo',
    countryNameLocal: 'République du Congo',
    countryCode: 'CG',
    currencyCode: 'XAF',
    currencyNameEn: 'CFA franc BEAC',
    tinType: '',
    tinName: '',

    countryCallingCode: '242',
    region: 'Africa',
    flag: '🇨🇬',
  },
  {
    countryNameEn: 'Czechia',
    countryNameLocal: 'Česká republika',
    countryCode: 'CZ',
    currencyCode: 'CZK',
    currencyNameEn: 'Czech koruna',
    tinType: 'DIČ',
    tinName: 'Daňové identifikační číslo',
    countryCallingCode: '420',
    region: 'Europe',
    flag: '🇨🇿',
  },
  {
    countryNameEn: 'United Kingdom',
    countryNameLocal: 'Great Britain',
    countryCode: 'GB',
    currencyCode: 'GBP',
    currencyNameEn: 'Pound sterling',
    tinType: 'VAT Reg No',
    tinName: 'Value added tax registration number',
    countryCallingCode: '44',
    region: 'Europe',
    flag: '🇬🇧',
  },
  {
    countryNameEn: 'Niger',
    countryNameLocal: 'Niger',
    countryCode: 'NE',
    currencyCode: 'XOF',
    currencyNameEn: 'CFA franc BCEAO',
    tinType: '',
    tinName: '',

    countryCallingCode: '227',
    region: 'Africa',
    flag: '🇳🇪',
  },
  {
    countryNameEn: 'Democratic Republic of the Congo',
    countryNameLocal: 'Democratic Republic of the Congo',
    countryCode: 'CD',
    currencyCode: 'CDF',
    currencyNameEn: 'Congolese franc',
    tinType: '',
    tinName: '',

    countryCallingCode: '243',
    region: 'Africa',
    flag: '🇨🇩',
  },
  {
    countryNameEn: 'Commonwealth of The Bahamas',
    countryNameLocal: 'Commonwealth of The Bahamas',
    countryCode: 'BS',
    currencyCode: 'BSD',
    currencyNameEn: 'Bahamian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1 242',
    region: 'Caribbean',
    flag: '🇧🇸',
  },
  {
    countryNameEn: 'Cocos (Keeling) Islands',
    countryNameLocal: 'Pulu Kokos (Keeling)',
    countryCode: 'CC',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '61 891',
    region: 'Australia',
    flag: '🇨🇨',
  },
  {
    countryNameEn: 'Central African Republic',
    countryNameLocal: 'République centrafricaine',
    countryCode: 'CF',
    currencyCode: 'XAF',
    currencyNameEn: 'Central African CFA',
    tinType: '',
    tinName: '',

    countryCallingCode: '236',
    region: 'Africa',
    flag: '🇨🇫',
  },
  {
    countryNameEn: 'Cook Islands',
    countryNameLocal: "Kūki 'Āirani",
    countryCode: 'CK',
    currencyCode: 'NZD',
    currencyNameEn: 'New Zealand dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '682',
    region: 'South Pacific Ocean',
    flag: '🇨🇰',
  },
  {
    countryNameEn: 'Falkland Islands',
    countryNameLocal: 'Falkland Islands',
    countryCode: 'FK',
    currencyCode: 'FKP',
    currencyNameEn: 'Falklands pound',
    tinType: '',
    tinName: '',
    countryCallingCode: '500',
    region: 'South Atlantic Ocean',
    flag: '🇫🇰',
  },
  {
    countryNameEn: 'Faroe Islands',
    countryNameLocal: 'Færøerne',
    countryCode: 'FO',
    currencyCode: 'DKK',
    currencyNameEn: 'Faroese króna',
    tinType: '',
    tinName: '',

    countryCallingCode: '298',
    region: 'Europe',
    flag: '🇫🇴',
  },
  {
    countryNameEn: 'Territory of Heard Island and McDonald Islands',
    countryNameLocal: 'Territory of Heard Island and McDonald Islands',
    countryCode: 'HM',
    currencyCode: 'AUD',
    currencyNameEn: 'Australian dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '672',
    region: 'Indian Ocean',
    flag: '🇭🇲',
  },
  {
    countryNameEn: 'British Indian Ocean Territory',
    countryNameLocal: 'British Indian Ocean Territory',
    countryCode: 'IO',
    currencyCode: 'USD',
    currencyNameEn: 'United States Dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '246',
    region: 'Indian Ocean',
    flag: '🇮🇴',
  },
  {
    countryNameEn: 'Comoros',
    countryNameLocal: 'Umoja wa Komori',
    countryCode: 'KM',
    currencyCode: 'KMF',
    currencyNameEn: 'Comorian franc',
    tinType: '',
    tinName: '',

    countryCallingCode: '269',
    region: 'Indian Ocean',
    flag: '🇰🇲',
  },
  {
    countryNameEn: 'Cayman Islands',
    countryNameLocal: 'Cayman Islands',
    countryCode: 'KY',
    currencyCode: 'KYD',
    currencyNameEn: 'Cayman Islands dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1 345',
    region: 'Caribbean Sea',
    flag: '🇰🇾',
  },
  {
    countryNameEn: 'Republic of the Marshall Islands',
    countryNameLocal: 'Aolepān Aorōkin Ṃajeḷ',
    countryCode: 'MH',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '692',
    region: 'Pacific Ocean',
    flag: '🇲🇭',
  },
  {
    countryNameEn: 'Commonwealth of the Northern Mariana Islands',
    countryNameLocal: 'Sankattan Siha Na Islas Mariånas',
    countryCode: 'MP',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1 670',
    region: 'Pacific Ocean',
    flag: '🇲🇵',
  },
  {
    countryNameEn: 'Turks and Caicos Islands',
    countryNameLocal: 'Turks and Caicos Islands',
    countryCode: 'TC',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '1 649',
    region: 'Atlantic Ocean',
    flag: '🇹🇨',
  },
  {
    countryNameEn: 'French Southern and Antarctic Lands',
    countryNameLocal: 'Terres australes et antarctiques françaises',
    countryCode: 'TF',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    countryCallingCode: '672',
    region: 'Indian Ocean',
    flag: '🇹🇫',
  },
  {
    countryNameEn: 'United States Minor Outlying Islands',
    countryNameLocal: 'United States Minor Outlying Islands',
    countryCode: 'UM',
    currencyCode: 'USD',
    currencyNameEn: 'United States dollar',
    tinType: '',
    tinName: '',
    countryCallingCode: '246',
    region: 'Pacific Ocean',
    flag: '🇺🇲',
  },
  {
    countryNameEn: 'Holy See',
    countryNameLocal: 'Sancta Sedes',
    countryCode: 'VA',
    currencyCode: 'EUR',
    currencyNameEn: 'Euro',
    tinType: '',
    tinName: '',
    countryCallingCode: '39',
    region: 'Europe',
    flag: '🇻🇦',
  },
]

export default countries
